// eslint-disable-next-line no-unused-vars
import React, { useCallback, useMemo } from 'react'
import { useQuery } from '@apollo/client'
import { listStaffMembersForStoreQuery } from '../../graphql/StaffMemberForStoreQuery'

export const useStaffMembers = (storeId, storepage, { skip: skipProp } = {}) => {
  const resolvedStoreId =
    storeId != null && storeId !== '' ? String(storeId) : null
  const skip = skipProp || !resolvedStoreId

  const { loading, data } = useQuery(listStaffMembersForStoreQuery, {
    variables: { storeId: resolvedStoreId, extended: !!storepage },
    skip,
  })

  const sortByName = useCallback((a, b) => {
    const aName = `${a.firstName} ${a.lastName}`
    const bName = `${b.firstName} ${b.lastName}`
    if (aName > bName) {
      return 1
    } else if (bName > aName) {
      return -1
    }

    return 0
  }, [])

  const sorted = useMemo(
    () => [...(data?.staffMember?.staffMembers || [])].sort(sortByName),
    [data, sortByName]
  )

  return { loading, staffMembers: sorted }
}
